import { render, staticRenderFns } from "./HeaderMainBasketDropdown.vue?vue&type=template&id=65e9d152&scoped=true&"
import script from "./HeaderMainBasketDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderMainBasketDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMainBasketDropdown.vue?vue&type=style&index=0&id=65e9d152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e9d152",
  null
  
)

export default component.exports